import { render, staticRenderFns } from "./categoryItemModal.vue?vue&type=template&id=4fe6a794"
import script from "../../controllers/library/category-item-modal.js?vue&type=script&lang=js&external"
export * from "../../controllers/library/category-item-modal.js?vue&type=script&lang=js&external"
import style0 from "./categoryItemModal.vue?vue&type=style&index=0&id=4fe6a794&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports